// This file handles edge cases that don't neatly fall into a pass
//
// In particular, it considers cases where prior interventions have a
// direct impact on intervention selection.

import {
  interventionTypes,
  interventionSituationTypes,
} from '../constants';
import {
  LOG_DECISION_CONTEXT, // This config toggles logging
} from '../config';

export function checkForReadWithMeConditions(state, decisionContextAcrossPasses) {
  let intervention = null;
  if(state.isReadWithMeMode) {
    LOG_DECISION_CONTEXT && decisionContextAcrossPasses.push(
      "READ_WITH_ME_RULE - selected 'read with me' due to intervention history"
    );
    intervention = interventionTypes.readwithme;
  } else if(state.endOfPhrase) {
    let phraseIHistory = state.interventionHistoryByPhrase[state.phraseIndex];
    if(phraseIHistory && phraseIHistory.length > 2) {
      if(phraseIHistory > (.7 * state.storyPhrases[state.phraseIndex].length)) {
        intervention = interventionTypes.initiateReadWithMe;
      }
    }
  }
  return intervention;
}

export function checkForReread(state, decisionContextAcrossPasses) {
  let intervention = null;
  let currPhraseHasI = false;
  let phraseIHistory = state.interventionHistoryByPhrase[state.phraseIndex];
  if(phraseIHistory) {
    phraseIHistory.forEach(inter => {
      if(inter.situation == interventionSituationTypes.PHRASE) {
        currPhraseHasI = true;
      };
    });
  }
  if(currPhraseHasI) {
    if(state.endOfPhrase) {
      LOG_DECISION_CONTEXT && decisionContextAcrossPasses.push(
        "NO_INTERVENTIONS_DURING_REREAD_RULE - didn't intervene due to a phrase re-read"
      );
      intervention = interventionTypes.none;
    } else {
      LOG_DECISION_CONTEXT && decisionContextAcrossPasses.push(
        "NO_INTERVENTIONS_GIVE_WORD - give the word due to a re-read"
      );
      intervention = interventionTypes.giveword;
    }
  }
  return intervention;
}

export function checkForTooManyInterventions(state, decisionContextAcrossPasses) {
  let intervention = null;
  let phraseExceedsInterventionMax = false;
  let numInterventions = 0;
  let phraseIHistory = state.interventionHistoryByPhrase[state.phraseIndex];
  if(phraseIHistory) {
    phraseIHistory.forEach(inter => {
      if(inter.type != interventionTypes.giveword) {
        numInterventions++;
      };
    });
  }

  if(numInterventions > 2 && state.endOfPhrase) {
    LOG_DECISION_CONTEXT && decisionContextAcrossPasses.push(
      "EXCEEDED_WORD_INTERVENTION_COUNT - didn't intervene at phrase level due to many word interventions in phrase"
    );
    intervention = interventionTypes.none;
  }
  return intervention;
}